import { Fragment, ReactElement } from 'react';

import { useOidc } from '@changegps/access-identity';
import { EvoHeader } from '@changegps/horizon-component-library';
import {
  Avatar,
  Backdrop,
  Box,
  CircularProgress,
  Menu,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { MainHeaderButton } from '@/components';
import { useLogout } from '@/features/auth';
import { useUserQuery } from '@/features/users';

import { usePopover } from './hooks';

export const AppHeader = (): ReactElement => {
  const navigate = useNavigate();
  const { isOpen, id, anchorEl, toggle, close } = usePopover('files-popover');
  const { data: user } = useUserQuery();
  const logoutMutation = useLogout();
  const { logout } = useOidc();

  const userInitials = `${user?.first_name[0]}${user?.last_name[0]}`;

  const onLogoClick = () => {
    navigate('/home');
  };

  return (
    <Fragment>
      <EvoHeader company={user?.company_name || ''} onLogoClick={onLogoClick}>
        {user?.profile_pic ? (
          <Avatar alt="Remy Sharp" src={user?.profile_pic} />
        ) : (
          <Box
            style={{
              color: 'white',
              backgroundColor: '#973060',
              borderRadius: 25,
              padding: '7px 9px',
            }}
          >
            {userInitials}
          </Box>
        )}
        <MainHeaderButton open={isOpen} onClick={toggle}>
          {user?.full_name}
        </MainHeaderButton>

        <Menu
          id={id}
          MenuListProps={{
            disablePadding: true,
            sx: {
              width: anchorEl?.offsetWidth,
            },
          }}
          anchorEl={anchorEl}
          open={isOpen}
          onClose={close}
          sx={{
            '& .MuiPaper-root': {
              marginTop: '4px',
              marginRight: '12px',
            },
            zIndex: 10,
          }}
        >
          <MenuItem onClick={logout}>Logout</MenuItem>
        </Menu>
      </EvoHeader>

      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={logoutMutation.isPending || logoutMutation.isSuccess}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};
